import { c as _c } from "react/compiler-runtime";
import { ExportDropdown } from "@components/common/export/export-dropdown";
import { useDateTime } from "@hooks/use-date-time";
import { TEAMS_DISPLAY_NAME } from "@src/constants/team-constants";
import { downloadTeamData } from "@utils/file-data-export";
import { TableType } from "@utils/track-event/track-event-list";
import { useCallback } from "react";
/** Dropdown to export teams in the file format selected by the user */
export function BulkExportTeams(t0) {
  const $ = _c(11);
  const {
    selectedTeams,
    areEntitiesSelected,
    buttonType: t1
  } = t0;
  const buttonType = t1 === undefined ? "bulk" : t1;
  const {
    formatDate
  } = useDateTime();
  let t2;
  if ($[0] !== formatDate || $[1] !== selectedTeams) {
    t2 = async format => await downloadTeamData(selectedTeams, formatDate, format);
    $[0] = formatDate;
    $[1] = selectedTeams;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const exportHandler = t2;
  let t3;
  if ($[3] !== areEntitiesSelected || $[4] !== selectedTeams.length) {
    t3 = {
      dataType: TableType.teams,
      numberOfEntities: selectedTeams.length,
      areEntitiesSelected
    };
    $[3] = areEntitiesSelected;
    $[4] = selectedTeams.length;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      success: `Successfully exported ${TEAMS_DISPLAY_NAME}.`,
      error: `Cannot export ${TEAMS_DISPLAY_NAME}. Please try again.`
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== buttonType || $[8] !== exportHandler || $[9] !== t3) {
    t5 = <ExportDropdown trackingProps={t3} exportHandler={exportHandler} toastMessage={t4} buttonTooltipText={`Export ${TEAMS_DISPLAY_NAME}`} buttonType={buttonType} />;
    $[7] = buttonType;
    $[8] = exportHandler;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}